(function () {
  if (window.__pdpSupplyBadgeInit) {
    if (typeof window.__pdpSupplyBadgeApply === 'function') window.__pdpSupplyBadgeApply();
    return;
  }
  window.__pdpSupplyBadgeInit = true;

  var EASTERN_TIME_ZONE = 'America/New_York';

  function parseDate(value) {
    var raw = String(value || '').trim();
    var iso = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    var us = raw.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})/);
    var year;
    var month;
    var day;

    if (iso) {
      year = Number(iso[1]);
      month = Number(iso[2]);
      day = Number(iso[3]);
    } else if (us) {
      month = Number(us[1]);
      day = Number(us[2]);
      year = Number(us[3]);
    } else {
      return null;
    }

    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    return { year: year, month: month, day: day };
  }

  function parseTime(value, fallback) {
    var raw = String(value || '').trim();
    if (!raw) return fallback;
    var match = raw.match(/^(\d{1,2})(?::(\d{2}))?(?::(\d{2}))?\s*([ap]m)?$/i);
    if (!match) return null;
    var hour = Number(match[1]);
    var minute = Number(match[2] || 0);
    var second = Number(match[3] || 0);
    var meridiem = (match[4] || '').toLowerCase();

    if (meridiem === 'pm' && hour < 12) hour += 12;
    if (meridiem === 'am' && hour === 12) hour = 0;
    if (hour > 23 || minute > 59 || second > 59) return null;
    return { hour: hour, minute: minute, second: second };
  }

  function zoneOffsetMs(timeZone, date) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).formatToParts(date);
    var map = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });

    var hour = map.hour === '24' ? 0 : Number(map.hour);
    var asUtc = Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), hour, Number(map.minute), Number(map.second));
    return asUtc - date.getTime();
  }

  function zonedStampToUtc(dateParts, timeParts, timeZone) {
    var utcGuess = Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day, timeParts.hour, timeParts.minute, timeParts.second);
    var offset = zoneOffsetMs(timeZone, new Date(utcGuess));
    var utc = utcGuess - offset;
    var corrected = zoneOffsetMs(timeZone, new Date(utc));
    return utcGuess - corrected;
  }

  function shopOffsetMs(offset) {
    var match = String(offset || '').trim().match(/^([+-])(\d{2}):?(\d{2})$/);
    if (!match) return null;
    var sign = match[1] === '-' ? -1 : 1;
    return sign * ((Number(match[2]) * 60) + Number(match[3])) * 60000;
  }

  function wallTimeToUtc(dateParts, timeParts, badge) {
    var timeZone = badge.getAttribute('data-timezone') || EASTERN_TIME_ZONE;
    if (timeZone === 'shop') {
      var offset = shopOffsetMs(badge.getAttribute('data-shop-offset'));
      if (offset == null) return zonedStampToUtc(dateParts, timeParts, EASTERN_TIME_ZONE);
      return Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day, timeParts.hour, timeParts.minute, timeParts.second) - offset;
    }
    return zonedStampToUtc(dateParts, timeParts, timeZone);
  }

  function boundary(dateValue, timeValue, fallbackTime, badge) {
    var dateParts = parseDate(dateValue);
    if (!dateParts) return null;
    var timeParts = parseTime(timeValue, fallbackTime);
    if (!timeParts) return null;
    return wallTimeToUtc(dateParts, timeParts, badge);
  }

  function applySchedule() {
    var now = Date.now();

    document.querySelectorAll('[data-pdp-supply-badge]').forEach(function (badge) {
      var start = boundary(
        badge.getAttribute('data-start-date'),
        badge.getAttribute('data-start-time'),
        { hour: 0, minute: 0, second: 0 },
        badge
      );
      var end = boundary(
        badge.getAttribute('data-end-date'),
        badge.getAttribute('data-end-time'),
        { hour: 23, minute: 59, second: 59 },
        badge
      );
      var visible = true;

      if (start != null && now < start) visible = false;
      if (end != null && now >= end) visible = false;
      badge.hidden = !visible;
    });
  }

  window.__pdpSupplyBadgeApply = applySchedule;
  applySchedule();
  document.addEventListener('shopify:section:load', applySchedule);
  window.addEventListener('pageshow', applySchedule);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) applySchedule();
  });
  window.setInterval(applySchedule, 1000);
})();
